import React, { useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  admin_update_sms_templates,
  admin_update_email_templates,
  admin_update_notification_templates,
} from "../../../../../store/actions/SuperAdminActions/adminTemplatesAction";

const OnHoldModalPopup = (props) => {
  const [showHoldModal, setShowHoldModal] = useState(false);

  const handleHoldModal = (templateData, actionBy) => {
    const token = props.auth.user.accessToken;
    const formData = {
      isHold: templateData.isHold === true ? false : true,
    };
    if (actionBy === "SMS") {
      props.admin_update_sms_templates(
        templateData._id,
        token,
        formData,
        (data) => onSuccess(data, actionBy)
      );
    } else if (actionBy === "EMAIL") {
      props.admin_update_email_templates(
        templateData._id,
        token,
        formData,
        (data) => onSuccess(data, actionBy)
      );
    } else if (actionBy === "NOTIFICATION") {
      props.admin_update_notification_templates(
        templateData._id,
        token,
        formData,
        (data) => onSuccess(data, actionBy)
      );
    }
  };

  const onSuccess = (templateData, actionBy) => {
    onHoldModalClosed();
    Alert.success(
      `<h4>${
        actionBy === "SMS"
          ? "SMS"
          : actionBy === "EMAIL"
          ? "Email"
          : actionBy === "NOTIFICATION"
          ? "Notification"
          : ""
      } Template ${templateData.isHold ? "Hold" : "UnHold"} Successfully</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  const onHoldModalClosed = () => {
    setShowHoldModal(false);
  };

  const handleShowDeleteOffer = () => {
    setShowHoldModal(true);
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        type="button"
        className={` mr-3 ${
          props.dataInfo.isHold ? "enIconBtnGray" : "enIconBtn"
        }`}
        onClick={handleShowDeleteOffer}
      >
        <i
          className="fa fa-pause-circle-o"
          aria-hidden="true"
          style={{
            fontSize: "20px",
            color: "#21212195",
            fontWeight: "100",
          }}
        ></i>
      </Button>
      <Modal show={showHoldModal} onHide={onHoldModalClosed} centered>
        <Modal.Header className="py-0 pt-4 border-0" closeButton>
          <Modal.Title className="f16-500">
            Are you sure to {props.dataInfo.isHold ? "UnHold" : "Hold"} this
            template ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500"></Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={onHoldModalClosed}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => handleHoldModal(props.dataInfo, props.actionBy)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

OnHoldModalPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  admin_update_sms_templates: PropTypes.func.isRequired,
  admin_update_email_templates: PropTypes.func.isRequired,
  admin_update_notification_templates: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  admin_update_sms_templates,
  admin_update_email_templates,
  admin_update_notification_templates,
})(OnHoldModalPopup);
